module.exports = __webpack_public_path__ + "img/kaiyuan.ec0f3e1f.png";